/**
 * @generated SignedSource<<c3f7cdb82018bba9640ab5365a1f9f1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type docktype = "DOCK" | "G47" | "GROUND" | "PEDESTAL" | "UNKNOWN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DocksList_docks$data = {
  readonly docks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly accessPoint: {
          readonly displayName: string;
          readonly id: string;
          readonly skydioSerial: string;
          readonly vehicleId: string | null;
        } | null;
        readonly displayName: string;
        readonly dockId: string;
        readonly dockType: docktype;
        readonly id: string;
        readonly isOnline: boolean | null;
        readonly organization: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly organizationId: string | null;
        readonly release: {
          readonly id: string;
          readonly releaseKey: string;
          readonly versionString: string | null;
        } | null;
        readonly skydioSerial: string | null;
        readonly uuid: string;
        readonly vehicle: {
          readonly displayName: string;
          readonly id: string;
          readonly skydioSerial: string | null;
          readonly vehicleId: string;
        } | null;
      } | null;
    } | null>;
    readonly totalCount: number;
  } | null;
  readonly " $fragmentType": "DocksList_docks";
};
export type DocksList_docks$key = {
  readonly " $data"?: DocksList_docks$data;
  readonly " $fragmentSpreads": FragmentRefs<"DocksList_docks">;
};

import DocksRefetchQuery_graphql from './DocksRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "docks"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skydioSerial",
  "storageKey": null
},
v4 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vehicleId",
    "storageKey": null
  },
  (v2/*: any*/),
  (v3/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "count"
    },
    {
      "kind": "RootArgument",
      "name": "cursor"
    },
    {
      "kind": "RootArgument",
      "name": "dockTypes"
    },
    {
      "kind": "RootArgument",
      "name": "organizationUuid"
    },
    {
      "kind": "RootArgument",
      "name": "releaseUuid"
    },
    {
      "kind": "RootArgument",
      "name": "searchTerm"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": DocksRefetchQuery_graphql
    }
  },
  "name": "DocksList_docks",
  "selections": [
    {
      "alias": "docks",
      "args": [
        {
          "kind": "Variable",
          "name": "dockTypes",
          "variableName": "dockTypes"
        },
        {
          "kind": "Variable",
          "name": "organizationUuid",
          "variableName": "organizationUuid"
        },
        {
          "kind": "Variable",
          "name": "releaseUuid",
          "variableName": "releaseUuid"
        },
        {
          "kind": "Variable",
          "name": "searchTerm",
          "variableName": "searchTerm"
        }
      ],
      "concreteType": "DockConnection",
      "kind": "LinkedField",
      "name": "__DocksList_docks_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DockEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Dock",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uuid",
                  "storageKey": null
                },
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dockId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dockType",
                  "storageKey": null
                },
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "organizationId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Organization",
                  "kind": "LinkedField",
                  "name": "organization",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Release",
                  "kind": "LinkedField",
                  "name": "release",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "releaseKey",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "versionString",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isOnline",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Vehicle",
                  "kind": "LinkedField",
                  "name": "vehicle",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccessPoint",
                  "kind": "LinkedField",
                  "name": "accessPoint",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "8746da32f458f477443f6f137dbeab71";

export default node;
